import { FC, ReactNode } from 'react';
import { FillingExperienceContextProps } from './filling-experience.context';
import FillingExperienceMain from './filling-experience.main';

type FillingExperienceWrapperProps = FillingExperienceContextProps & {
  children: ReactNode;
};

export const FillingExperienceWrapper: FC<FillingExperienceWrapperProps> = ({ children, ...contextProps }) => {
  return <FillingExperienceMain {...contextProps}>{children}</FillingExperienceMain>;
};
